<div style="margin-top: 57px;">
  <p-table
    #dt1 
    [value]="tenantList" 
    [tableStyle]="{ 'width': '75%', 'margin-left': 'auto', 'margin-right': 'auto'}" 
    styleClass="p-datatable-striped p-datatable-gridlines"
    dataKey="id"
    selectionMode="single"
    [(selection)]="selected"
    [paginator]="true"
    [rows]="50"
    [loading]="loading"
    responsiveLayout="stack" 
    [breakpoint]="'500px'"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['name','id','description']"
  >
    <ng-template pTemplate="caption">
      <div class="title">{{ "tenants" | translate }}</div>
      <div class="relative mb-3">
        <input
          pInputText
          style="float: left; margin-left: 11.8%; width: 25%; background-color: var(--list-bg-color); color: var(--text-color); -webkit-transition: 0s; transition: 0s;"
          type="text"
          placeholder="Search"
          (input)="dt1.filterGlobal($any($event.target).value, 'contains')" 
          class="pl-3 pr-3 border border-gray-300 focus:border-blue-500 h-10 outline-none font-sans text-lg font-light"
        >
        <i class="pi pi-search object-right items-center -ml-6 text-gray-400 mt-3"></i>
        <button
          style="float: right; margin-right: 11.8%; width: 260px"
          class=" items-center justify-center text-center button w-40 h-10 rounded text-lg cursor-pointer"
          (click)="jumpCreateTenant()"
        >
          {{"addTenant" | translate}}
        </button>
      </div>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr [pSelectableRow]="rowData" style="border: 1px solid var(--list-border-color); background-color: var(--list-bg-color); cursor: auto">
        <td class="truncate font-sans text-sm">
          <div class="name-area">
            <div class="tenant-name" style="overflow: hidden; text-overflow: ellipsis; max-width: 800px;"> {{rowData.name}} </div>
          </div>
          <div class="tenant-id-area"> 
            ID: {{rowData.id}} 
            <button
              style="width: 45px; display: inline-block; border: 1px solid; margin-left: 3px;"
              class="items-center justify-center text-center font-inter cursor-pointer rounded"
              (click)="copyTenantId(rowData.id)"
            >
              {{"copy" | translate}}
            </button>
          </div>
          <hr style="width: 120%; margin-left: -30px; border-color: var(--list-border-color);">
          <div style="float: top;">
            <div class="details-area">
              <div class="details">
                {{rowData.description}}
              </div>
              <div class="header"> {{"tenantDescription" | translate}} </div>
            </div>
          </div>
          <div>
            <div class="btn">
              <button *ngIf="!auth.isYakuin" mat-raised-button style="background-color: #28b6c7; width: 105px" (click)="onButtonClick(rowData)">
                {{"viewEdit" | translate}}
              </button>
            </div>
          </div>
        </td>
      </tr>
      <br>
    </ng-template>
  </p-table>
  <br />
</div>